var React = require('react');

function IconAlert (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.731 19.093C2.054 20.423 3.021 22 4.514 22h14.97c1.493 0 2.46-1.576 1.783-2.907L13.782 4.377c-.742-1.457-2.824-1.457-3.566 0L2.731 19.093zm10.245-.429h-1.954V16.44h1.954v2.224zm0-4.448h-1.954V9.768h1.954v4.448z","fill":"#A3A1A7"}));
}

IconAlert.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconAlert;

IconAlert.default = IconAlert;
